import { PlugIcon } from "lucide-react";

import type { RuntimePlugin } from "@mlx/contracts";
import { cn } from "@/lib/utils";

/**
 * The branding subset the icon reads — structurally identical to the client's
 * RuntimePluginSummary. Declared here from the contract type rather than
 * imported from `@/lib/mlx-client`, so surfaces that render plugin branding
 * from static data (print, export, the marketing product bridge) can import
 * this file without the live data client entering their module graph.
 */
export type PluginIconPlugin = Pick<RuntimePlugin, "slug" | "label" | "branding">;

export function PluginIcon(props: {
  plugin: PluginIconPlugin;
  className?: string;
}) {
  const { plugin, className } = props;
  if (plugin.branding?.iconUrl) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        alt=""
        aria-hidden="true"
        className={cn("h-4 w-4 object-contain", className)}
        src={plugin.branding.iconUrl}
      />
    );
  }
  return <PlugIcon className={cn("h-4 w-4 text-muted-foreground", className)} />;
}
